import Localization from './Localization';
import Assets from './Assets';

export class Information {
	_id: string;
	from: Date;
	to: Date;
	title: Localization;
	description: Localization;
	image: Assets;
	url: string;
	actions: [
		{
			type: InformationActionType;
			name: Localization;
		},
	];
}

export enum InformationActionType {
	CANCEL = 'CANCEL',
	PRIMARY = 'PRIMARY',
	SECONDARY = 'SECONDARY',
}
